module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/realsimple-f65223637e32f6f8701fddef197cd875.png";